import React, { useState, useEffect, useRef } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { TextField, FormGroup, FormControlLabel, Checkbox, Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function validateEmail(email) {
  if (!email || email === '') return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

const DIPLOMES = [
  { value: 'Baccalauréat', label: 'Baccalauréat' },
  { value: 'BTS', label: 'BTS' },
  { value: 'DUT', label: 'DUT' },
  { value: 'Licence', label: 'Licence' },
  { value: 'Master', label: 'Master' },
  { value: 'Doctorat', label: 'Doctorat' },
];

const SERIES_BAC = [
  { value: 'Série A', label: 'Série A' },
  { value: 'Série D', label: 'Série D' },
  { value: 'Série C', label: 'Série C' },
];

const CYCLES = [
  { value: 'congolais', label: 'Cycle congolais' },
  { value: 'francais', label: 'Cycle français' },
];

const formatTelephone = /^(06|05|04)[0-9]{7}$/;

const Step2 = (props) => {
  const {
    setShowBtn,
    dernierDiplome,
    setDernierDiplome,
    diplomaDetail,
    setDiplomaDetail,
    diplomeFichier,
    setDiplomeFichier,
    cyclesEnseignement,
    setCyclesEnseignement,
    experienceParCycle,
    setExperienceParCycle,
    referencesPro,
    setReferencesPro,
    email,
    setEmail,
    isEdit = false,
  } = props;

  const [detailTouched, setDetailTouched] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [msgDernierDiplome, setMsgDernierDiplome] = useState('');
  const [msgDiplomaDetail, setMsgDiplomaDetail] = useState('');
  const [msgDiplomeFichier, setMsgDiplomeFichier] = useState('');
  const [msgCycle, setMsgCycle] = useState('');
  const [msgExperience, setMsgExperience] = useState('');
  const [msgReferences, setMsgReferences] = useState('');
  const [msgEmail, setMsgEmail] = useState('');
  const prevIsBacRef = useRef(dernierDiplome === 'Baccalauréat');

  const isBac = dernierDiplome === 'Baccalauréat';
  const refsValid = referencesPro.filter(r => {
    const num = typeof r === 'object' ? r?.number : r;
    return num && formatTelephone.test(String(num).trim());
  }).length >= 1;

  const cyclesValid = cyclesEnseignement.length >= 1;
  const experienceValid = cyclesEnseignement.every(
    (c) => experienceParCycle[c] !== undefined && experienceParCycle[c] !== '' && Number(experienceParCycle[c]) >= 0
  );
  const detailValid = !dernierDiplome || (isBac ? SERIES_BAC.some(s => s.value === diplomaDetail) : diplomaDetail.trim() !== '');
  const diplomeFichierValid = !dernierDiplome || !!diplomeFichier || isEdit;

  useEffect(() => {
    const wasBac = prevIsBacRef.current;
    if (wasBac && !isBac) setDiplomaDetail('');
    prevIsBacRef.current = isBac;
  }, [isBac, setDiplomaDetail]);

  useEffect(() => {
    const ok =
      dernierDiplome &&
      detailValid &&
      diplomeFichierValid &&
      cyclesValid &&
      experienceValid &&
      refsValid &&
      (email === '' || validateEmail(email));
    setShowBtn(!!ok);
  }, [dernierDiplome, diplomaDetail, detailValid, diplomeFichierValid, cyclesValid, experienceValid, refsValid, email, setShowBtn, isBac, diplomeFichier, isEdit]);

  useEffect(() => {
    if (!showValidation) { setMsgDernierDiplome(''); return; }
    setMsgDernierDiplome(dernierDiplome ? '' : "Le dernier diplôme est obligatoire");
  }, [dernierDiplome, showValidation]);

  useEffect(() => {
    if (!dernierDiplome) {
      setMsgDiplomaDetail('');
      return;
    }
    if (!detailTouched) {
      setMsgDiplomaDetail('');
      return;
    }
    if (isBac) setMsgDiplomaDetail(diplomaDetail ? '' : "Veuillez sélectionner la série (A, D ou C)");
    else setMsgDiplomaDetail(diplomaDetail.trim() ? '' : "Veuillez saisir les détails (ex: spécialité)");
  }, [dernierDiplome, diplomaDetail, isBac, detailTouched]);

  useEffect(() => {
    if (!showValidation || isEdit) { setMsgDiplomeFichier(''); return; }
    setMsgDiplomeFichier(dernierDiplome && !diplomeFichier ? 'Le téléversement du diplôme est obligatoire' : '');
  }, [dernierDiplome, diplomeFichier, showValidation, isEdit]);

  useEffect(() => {
    if (!showValidation) { setMsgCycle(''); return; }
    setMsgCycle(cyclesValid ? '' : "Sélectionnez au moins un cycle d'enseignement");
  }, [cyclesValid, showValidation]);

  useEffect(() => {
    if (!showValidation) { setMsgExperience(''); return; }
    setMsgExperience(experienceValid ? '' : "Indiquez le nombre d'années d'expérience pour chaque cycle sélectionné");
  }, [experienceValid, cyclesEnseignement, showValidation]);

  useEffect(() => {
    if (!showValidation) { setMsgReferences(''); return; }
    setMsgReferences(refsValid ? '' : 'Au moins un numéro de référence professionnelle est requis (format 06/05/04 + 7 chiffres)');
  }, [refsValid, showValidation]);

  useEffect(() => {
    if (email === '') setMsgEmail('');
    else setMsgEmail(validateEmail(email) ? '' : "L'email n'est pas valide");
  }, [email]);

  const toggleCycle = (value) => {
    setShowValidation(true);
    if (cyclesEnseignement.includes(value)) {
      setCyclesEnseignement(cyclesEnseignement.filter((c) => c !== value));
      setExperienceParCycle((prev) => {
        const next = { ...prev };
        delete next[value];
        return next;
      });
    } else {
      setCyclesEnseignement([...cyclesEnseignement, value]);
      setExperienceParCycle((prev) => ({ ...prev, [value]: '' }));
    }
  };

  const setExperienceForCycle = (cycle, val) => {
    setExperienceParCycle((prev) => ({ ...prev, [cycle]: val }));
  };

  const addReference = () => {
    setShowValidation(true);
    setReferencesPro([...referencesPro, { name: '', number: '' }]);
  };
  const removeReference = (i) => setReferencesPro(referencesPro.filter((_, idx) => idx !== i));
  const setReference = (i, field, v) => {
    const next = [...referencesPro];
    const current = next[i] && typeof next[i] === 'object' ? next[i] : { name: '', number: next[i] || '' };
    next[i] = { ...current, [field]: v };
    setReferencesPro(next);
  };

  return (
    <div className="text-center mt-4">
      <FormControl sx={{ width: '100%', mb: 2 }}>
        <InputLabel>Dernier diplôme obtenu</InputLabel>
        <Select
          value={dernierDiplome}
          label="Dernier diplôme obtenu"
          onChange={(e) => {
            const v = e.target.value;
            if (dernierDiplome === 'Baccalauréat' && v !== 'Baccalauréat') setDiplomaDetail('');
            setDernierDiplome(v);
          }}
          onBlur={() => setShowValidation(true)}
        >
          {DIPLOMES.map((d) => (
            <MenuItem key={d.value} value={d.value}>{d.label}</MenuItem>
          ))}
        </Select>
        <p style={{ color: 'red' }}>{msgDernierDiplome}</p>
      </FormControl>

      {dernierDiplome && (
        <>
          <FormControl sx={{ width: '100%', mb: 2 }}>
            {isBac ? (
              <>
                <InputLabel>Détail (série bac)</InputLabel>
                <Select
                  value={diplomaDetail}
                  label="Détail (série bac)"
                  onChange={(e) => setDiplomaDetail(e.target.value)}
                  onBlur={() => setDetailTouched(true)}
                >
                  {SERIES_BAC.map((s) => (
                    <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
                  ))}
                </Select>
              </>
            ) : (
              <TextField
                fullWidth
                label="Détails (ex: spécialité)"
                value={diplomaDetail}
                onChange={(e) => setDiplomaDetail(e.target.value)}
                onBlur={() => setDetailTouched(true)}
                placeholder="Ex: Licence en Mathématiques"
                variant="outlined"
                error={Boolean(msgDiplomaDetail)}
                helperText={msgDiplomaDetail}
              />
            )}
            <p style={{ color: 'red' }}>{msgDiplomaDetail}</p>
          </FormControl>

          <p style={{ marginTop: 8, marginBottom: 4, fontWeight: 500 }}>Téléversement du diplôme {isEdit ? '(optionnel en mise à jour)' : '(obligatoire)'}</p>
          <Box
            component="label"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 3,
              px: 2,
              mb: 2,
              border: '2px dashed',
              borderColor: diplomeFichier ? 'success.main' : 'divider',
              borderRadius: 2,
              bgcolor: diplomeFichier ? 'action.selected' : 'action.hover',
              cursor: 'pointer',
              transition: 'border-color 0.2s, background-color 0.2s',
              '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
            }}
          >
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => { setShowValidation(true); setDiplomeFichier(e.target.files?.[0] || null); }}
              style={{ display: 'none' }}
            />
            <CloudUploadIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
            <span style={{ color: 'text.secondary', fontSize: '0.875rem' }}>
              {diplomeFichier ? diplomeFichier.name : 'Cliquez ou glissez un fichier (PDF, JPG, PNG)'}
            </span>
            {msgDiplomeFichier && <p style={{ color: 'red', margin: '4px 0 0', fontSize: '0.75rem' }}>{msgDiplomeFichier}</p>}
          </Box>
        </>
      )}

      <FormControl component="fieldset" sx={{ width: '100%', mb: 2, textAlign: 'left' }}>
        <InputLabel shrink sx={{ position: 'relative', ml: -0.5 }}>Vous enseignez dans quel(s) cycle(s) ?</InputLabel>
        <FormGroup row sx={{ mt: 1.5 }}>
          {CYCLES.map((c) => (
            <FormControlLabel
              key={c.value}
              control={
                <Checkbox
                  checked={cyclesEnseignement.includes(c.value)}
                  onChange={() => toggleCycle(c.value)}
                  name={c.value}
                />
              }
              label={c.label}
            />
          ))}
        </FormGroup>
        <p style={{ color: 'red' }}>{msgCycle}</p>
      </FormControl>

      {cyclesEnseignement.length > 0 && (
        <div style={{ marginBottom: 16, textAlign: 'left' }}>
          <p style={{ marginBottom: 8, fontWeight: 500 }}>Années d'expérience pour chaque cycle sélectionné</p>
          {cyclesEnseignement.map((cycleKey) => {
            const label = CYCLES.find((c) => c.value === cycleKey)?.label || cycleKey;
            return (
              <TextField
                key={cycleKey}
                fullWidth
                type="number"
                label={`Années d'expérience — ${label}`}
                value={experienceParCycle[cycleKey] ?? ''}
                onChange={(e) => { setShowValidation(true); setExperienceForCycle(cycleKey, e.target.value); }}
                inputProps={{ min: 0 }}
                variant="outlined"
                sx={{ mb: 2 }}
              />
            );
          })}
          <p style={{ color: 'red' }}>{msgExperience}</p>
        </div>
      )}

      <p style={{ marginTop: 16, marginBottom: 8 }}>Références professionnelles</p>
      <p style={{ marginBottom: 8, fontSize: '0.875rem', color: 'text.secondary' }}>Nom (facultatif) et numéro — au moins un numéro requis.</p>
      {referencesPro.map((ref, i) => {
        const name = typeof ref === 'object' ? (ref?.name ?? '') : '';
        const number = typeof ref === 'object' ? (ref?.number ?? '') : (ref || '');
        return (
          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
            <TextField
              label="Nom (facultatif)"
              placeholder="Ex: École X"
              value={name}
              onChange={(e) => setReference(i, 'name', e.target.value)}
              sx={{ flex: '1 1 140px', minWidth: 120 }}
              variant="outlined"
              size="small"
            />
            <TextField
              label="Numéro"
              placeholder="061234567"
              value={number}
              onChange={(e) => { setShowValidation(true); setReference(i, 'number', e.target.value); }}
              error={!!number && !formatTelephone.test(String(number).trim())}
              helperText={number && !formatTelephone.test(String(number).trim()) ? 'Format: 06/05/04 + 7 chiffres' : ''}
              sx={{ flex: '1 1 140px', minWidth: 120 }}
              variant="outlined"
              size="small"
            />
            {referencesPro.length > 1 && (
              <Button type="button" variant="outlined" color="error" onClick={() => removeReference(i)} sx={{ minWidth: 44 }}>
                −
              </Button>
            )}
          </div>
        );
      })}
      <Button
        type="button"
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={addReference}
        sx={{
          mt: 1,
          mb: 2,
          borderStyle: 'dashed',
          borderWidth: 2,
          color: '#1d42d9',
          '&:hover': {
            borderStyle: 'dashed',
            borderWidth: 2,
            backgroundColor: 'rgba(29, 66, 217, 0.08)',
          },
        }}
      >
        Ajouter
      </Button>
      <p style={{ color: 'red' }}>{msgReferences}</p>

      <TextField
        fullWidth
        type="email"
        label="Adresse email (optionnel)"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Ex : john@example.com"
        variant="outlined"
        error={Boolean(msgEmail)}
        helperText={msgEmail}
        sx={{ mt: 2 }}
      />
    </div>
  );
};

export default Step2;
